import Svg from 'components/utilities/svg'

const DuplicateIcon = ({ ...props }) => (
  <Svg viewBox="0 0 14 14" {...props}>
    <title>Duplicate Icon</title>
    <path d="M5.25 10.5C4.92917 10.5 4.65451 10.3858 4.42604 10.1573C4.19757 9.92884 4.08333 9.65419 4.08333 9.33335V2.33335C4.08333 2.01252 4.19757 1.73787 4.42604 1.5094C4.65451 1.28092 4.92917 1.16669 5.25 1.16669H10.5C10.8208 1.16669 11.0955 1.28092 11.324 1.5094C11.5524 1.73787 11.6667 2.01252 11.6667 2.33335V9.33335C11.6667 9.65419 11.5524 9.92884 11.324 10.1573C11.0955 10.3858 10.8208 10.5 10.5 10.5H5.25ZM5.25 9.33335H10.5V2.33335H5.25V9.33335ZM2.91667 12.8334C2.59583 12.8334 2.32118 12.7191 2.09271 12.4906C1.86424 12.2622 1.75 11.9875 1.75 11.6667V3.50002H2.91667V11.6667H9.33333V12.8334H2.91667Z" />
  </Svg>
)

DuplicateIcon.displayName = 'Download'

export default DuplicateIcon
